import { isolatedPoolComptrollerAbi, legacyPoolComptrollerAbi } from 'libs/contracts';
import type { ChainId } from 'types';
import { isPoolIsolated } from 'utilities';
import type { Address, PublicClient } from 'viem';
import type { ApiPool } from '../getApiPools';
import { unwrapMulticallResult } from '../unwrapMulticallResult';

export const getUserCollateralAddresses = async ({
  accountAddress,
  apiPools,
  chainId,
  publicClient,
  legacyPoolComptrollerContractAddress,
}: {
  accountAddress: Address;
  apiPools: ApiPool[];
  chainId: ChainId;
  publicClient: PublicClient;
  legacyPoolComptrollerContractAddress?: Address;
}) => {
  const getAssetsInContracts = [];

  apiPools.forEach((pool) => {
    const isIsolated = isPoolIsolated({
      chainId,
      comptrollerAddress: pool.address,
    });

    if (!isIsolated) {
      return;
    }

    getAssetsInContracts.push({
      abi: isolatedPoolComptrollerAbi,
      address: pool.address,
      functionName: 'getAssetsIn',
      args: [accountAddress],
    } as const);
  });

  if (accountAddress && legacyPoolComptrollerContractAddress) {
    getAssetsInContracts.push({
      abi: legacyPoolComptrollerAbi,
      address: legacyPoolComptrollerContractAddress,
      functionName: 'getAssetsIn',
      args: [accountAddress],
    } as const);
  }

  if (getAssetsInContracts.length === 0) {
    return { userCollateralAddresses: [] };
  }

  const results = await publicClient.multicall({
    contracts: getAssetsInContracts,
  });

  return {
    userCollateralAddresses: results.flatMap((result) =>
      unwrapMulticallResult<readonly string[]>(result),
    ),
  };
};
